import { Divider, Form, Input } from 'antd';
import React, { useState } from 'react';
import { formValidatorRules } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';

const { Item } = Form;
const { TextArea } = Input;
const { required } = formValidatorRules;

const CancelSubscriptionModal = ({
  isModalOpen,
  setIsModalOpen,
  onFinish,
  loadings,
}) => {
  const [form] = Form.useForm();
  const [isValidateTrigger, setIsValidateTrigger] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsValidateTrigger(false);
    form?.resetFields();
  };

  const handleFinish = async (values) => {
    const isCancelled = await onFinish({ reason: values?.reason?.trim() });
    if (isCancelled) {
      handleCancel();
    }
  };

  return (
    <ModalComponent
      open={isModalOpen}
      onCancel={handleCancel}
      onOk={form?.submit}
      title="Cancel Subscription"
      okText="Cancel Subscription"
      cancelText="Close"
      confirmLoading={loadings}
      destroyOnClose
      forceRender
    >
      <Divider />
      <div className="mb-16">
        <Form
          form={form}
          onFinish={handleFinish}
          autoComplete="off"
          layout="vertical"
          validateTrigger={isValidateTrigger ? 'onChange' : 'onSubmit'}
          onFinishFailed={() => setIsValidateTrigger(true)}
        >
          <Item
            label="Reason"
            name="reason"
            rules={[{ ...required, message: 'Please Enter Reason!' }]}
          >
            <TextArea
              rows={4}
              allowClear
              placeholder="Enter reason for cancelling the subscription"
              showCount
              maxLength={500}
            />
          </Item>
        </Form>
      </div>
    </ModalComponent>
  );
};

export default CancelSubscriptionModal;
